import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { routes } from "./routes";

const Router = () => {
	const router = useMemo(() => createBrowserRouter(routes), []);

	return (
		<RouterProvider
			router={router}
			future={{
				v7_startTransition: true,
			}}
		/>
	);
};

export default Router;
